import React from 'react';
import { LOYALTY, PROMOTION_DELIVERY_FREE } from '../../../constants';
import { useAppSelector } from '../../../redux/hook';
import MinCartPriceInfo from './MinCartPriceInfo';
import SkeletonRow from '../../Skeleton/SkeletonRow.view';
import { Typography } from "@mui/material";

type OrderPromotionProps = {
  promotion: any;
  commande: any;
  promotionType: string;
  prefix: string;
  isLoading: boolean;
  freeDelivery?: boolean;
};

export default function OrderPromotion({
  promotion,
  commande,
  promotionType,
  prefix,
  isLoading,
  freeDelivery = false
}: OrderPromotionProps) {
  const { secondaryColor, name } = useAppSelector(
    (state) => state.configurationReducer
  );

  const isLoyalty = promotion?.promoCode === LOYALTY;
  const isFreeDelivery = promotion?.type === PROMOTION_DELIVERY_FREE;
  const getPromotionLabel = () => {
    if (isLoyalty) return `Fidélité ${name ?? ''}`;
    if (isFreeDelivery || freeDelivery) return 'Livraison offerte';
    return `Promotion ${promotion?.promoCode}`;
  };
  return (
    <div
      className={`${!commande && promotion.minBasketPrice && "strike-through-price"
        }`}
      style={{ display: "contents" }}
    >
      <SkeletonRow
        label={
          <Typography
            variant="body1"
            sx={{
              color: !commande && !promotion.minBasketPrice && secondaryColor,
            }}
          >
            {getPromotionLabel()}
            {promotion?.minBasketPrice > 0 && !commande && (
              <MinCartPriceInfo
                promoType={isLoyalty ? 'loyalty' : 'code-promo'}
                minBasketPrice={promotion?.minBasketPrice}
              />
            )}
          </Typography>
        }
        amount={
          <Typography
            variant="subtitle1"
            sx={{
              color: !commande && !promotion.minBasketPrice && secondaryColor,
            }}
          >
            {prefix}
            {promotionType}
          </Typography>
        }
        isLoading={isLoading}
      />
    </div>
  );
}
